import jQuery from "jquery";
window.$ = window.jQuery = jQuery;
require('./jquery/jquery.sidr.min.js');
require('./jquery/jquery-ui.js');
require('../../node_modules/jquery-cycle2-ibe/build/jquery.cycle2.min');

import '../less/style.less';

jQuery(function ($) {
    $('.logo-carousel').cycle({
        speed: 1000,
        manualSpeed: 100,
        timeout: 3000,
        slides: '> span',
        autoHeight: 'calc'
    });

    /* Roll down items */
    roll_down_items();

    /* Wrap Iframes */
    wrapIframes();

    /* Mobile menu */
    mobileMenu();

    /* Equal */
    makeEqual($('.feed .feed-item .inner'));

    /* Open close */
    initOC();

    /* Search */
    initSearch();

    /* Event carousel */
    eventRotation();
    eventViewSwitcher();

    $('#menu-trigger').sidr({
        side: 'right'
    });

    $('input[type=date]')
        .attr('type', 'text')
        .datepicker({
            // Consistent format with the HTML5 picker
            dateFormat: 'yy-mm-dd'
        });

    /*
     * Functions
     */
    function roll_down_items() {
        $('.slide-items .cnt').hide();
        $('.slide-link').click(function (e) {
            e.preventDefault();
            var prnt = $(this).parents('.item');
            var plus = $('.slide-link .plus span', prnt).is(":visible");
            // Slide Up all others than clicked
            $('.slide-items .cnt').not($('.cnt', prnt)).slideUp(function () {
                var prnt2 = $(this).parents('.item');
                $('.slide-link .plus span', prnt2).show();
            });
            $('.cnt', prnt).slideToggle(function () {
                if (!plus) {
                    $('.slide-link .plus span', prnt).show();
                }
            });
            if (plus) {
                $('.slide-link .plus span', prnt).hide();
            }
        });
        $('.slide-link:first').trigger('click');
    }

    /**
     * wrapIframes
     *
     * Function for wrapping iframes into embed-wrapper class -> Responsive sizes
     *
     * @access public
     * @return void
     */
    function wrapIframes() {
        $('iframe, object, embed').wrap("<div class='embed-wrapper'></div>");
    }

    /**
     * mobileMenu
     *
     * Slide up/down the menu for mobile devices
     *
     * @access public
     * @return void
     */
    function mobileMenu() {
        var menuTrigger = $('#menu-trigger');
        var menu = $('.header #menu-main-menu');

        if ((menuTrigger.length < 1) || (menu.length < 1)) return;

        menuTrigger.on('click', function () {
            menu.toggleClass('active');
            menu.slideToggle();
        });

        $('li.menu-item-has-children').click(function (e) {

            // If menuTrigger is not visible end function
            if (!menuTrigger.is(':visible')) return;

            if (!$(this).hasClass('active')) {
                e.preventDefault();
                $('a.menu-item-has-children', menu).removeClass('active');
                $('.sub-menu', menu).slideUp();
                $(this).addClass('active');
                $('.sub-menu', this).slideDown();
            }
        });
    }

    /**
     * makeEqual
     *
     * @param elements $elements
     * @access public
     * @return void
     */
    function makeEqual(elements) {
        var max = Math.max.apply(Math, elements.map(
            function () {
                return $(this).outerHeight();
            }
        ));
        max = max + 1; // border - dummy I know
        elements.css('min-height', max);
    }

    /**
     * Method: eventRotation
     *
     * Got from Markus nycgb carousel
     *
     * @return void
     */
    function eventRotation() {
        if ($('.events-carousel .navigation').length > 0) {
            $('.events-carousel .navigation').on('click', function (event) {
                event.preventDefault();
                if ($(this).hasClass('previous')) {
                    if (!$('.event-item:first').hasClass('counter--1')) {
                        $('.event-item').attr('class', function (i, c) {
                            val = c.replace(/\bcounter-\S+/g, '');
                            val = $.trim(val);
                            return val;
                        });
                        $('.event-item').each(function (i) {
                            var position = parseInt($(this).attr('data-position'));
                            position++;
                            $(this).attr('data-position', position);
                            $(this).addClass('counter-' + position);
                        });
                    }
                }

                if ($(this).hasClass('next')) {
                    if (!$('.event-item:last').hasClass('counter-0')) {
                        $('.event-item').attr('class', function (i, c) {
                            val = c.replace(/\bcounter-\S+/g, '');
                            val = $.trim(val);
                            return val;
                        });
                        $('.event-item').each(function (i) {
                            var position = parseInt($(this).attr('data-position'));
                            position--;
                            $(this).attr('data-position', position);
                            $(this).addClass('counter-' + position);
                        });
                    }
                }
            });
        }
    }

    /**
     * Method: eventViewSwitcher
     *
     * As well from nycgb Markus
     *
     * @return void
     */
    function eventViewSwitcher() {
        var reversed = false;
        if ($('.events-carousel').length > 0) {
            if ($('.events-carousel').hasClass('list')) {
                $('.events-carousel .list').parent().hide();
            } else if ($('.events-carousel').hasClass('carousel')) {
                $('.events-carousel .carousel').parent().hide();
            }
            $('.events-carousel .view-toggle').on('click', 'a', function (e) {
                e.preventDefault();
                var list;
                var listItems;
                if ($(this).attr('class') == 'carousel') {
                    if (reversed) {
                        list = $('.events-carousel .inner-content');
                        listItems = list.children('.event-item');
                        list.append(listItems.get().reverse());
                    }
                    $(this).closest('.events-carousel').removeClass('list').addClass('carousel');
                    $(this).parent().hide();
                    $(this).closest('.view-toggle').find('.list').parent().show();
                } else if ($(this).attr('class') == 'list') {
                    list = $('.events-carousel .inner-content');
                    listItems = list.children('.event-item');
                    list.append(listItems.get().reverse());
                    reversed = true;
                    $(this).closest('.events-carousel').removeClass('carousel').addClass('list');
                    $(this).parent().hide();
                    $(this).closest('.view-toggle').find('.carousel').parent().show();
                }
            });
        }

    }

    /**
     * Method: initOC
     *
     * Open close functionality.
     *
     * @return void
     */
    function initOC() {
        var ocLink = $('.oc-link');
        if (ocLink.length < 1) return;

        ocLink.on('click', function (e) {
            e.preventDefault();
            ocLink.not(this).next('.oc-cnt').slideUp();
            $(this).next('.oc-cnt').slideToggle();
        });
    }

    /**
     * initSearch
     *
     * @access public
     * @return void
     */
    function initSearch() {
        var button = $('.header .socials .search');
        button.on('click', function () {
            $('.header .search-inner').fadeToggle('fast');
        });

        var button2 = $('#sidr .socials .search');
        button2.on('click', function () {
            $('#sidr .search-inner').slideToggle('slow');
        });

        var button3 = $('.footer .socials .search');
        button3.on('click', function () {
            $('#menu-trigger').trigger('click');
            button2.trigger('click');
        });
    }

});
